module.exports = __webpack_public_path__ + "static/media/2023-SWG-Uni-Student-Offer-Tablet-700x400px-min.99c33712.jpg";